import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import { validateFields } from '../../../utility/validation';
import http, {
  AUTH,
  ACCESS_TOKEN,
  TOKEN_TYPE,
  TWO_FACTOR_AUTH,
} from '../../../utility/http';
import {
  API_2FA_LOGIN,
  API_2FA_VERIFY,
  API_ME,
} from '../../../constants/apiRoutes';
import StorageService from '../../../utility/storageService';
import fields from './fields';
import LoginAuthenticationFormLayout from './layout';

const LoginAuthenticationFormWithFormik = withFormik({
  mapPropsToValues: () => ({
    code: '',
  }),
  validate: async values => {
    throw await validateFields(fields, values);
  },
  enableReinitialize: true,
  validateOnBlur: false,
  handleSubmit: async (values, { props, setErrors, setSubmitting }) => {
    const twoFactorAuth = JSON.parse(StorageService.get(TWO_FACTOR_AUTH));
    http.defaults.headers.Authorization = `${TOKEN_TYPE} ${twoFactorAuth?.accessToken}`;

    const handleLogin = async () => {
      try {
        await http.post(API_2FA_LOGIN, { code: values.code }).then(response => {
          http.defaults.headers.Authorization = `${TOKEN_TYPE} ${response.data[ACCESS_TOKEN]}`;
          StorageService.set(
            TWO_FACTOR_AUTH,
            JSON.stringify({
              ...twoFactorAuth,
              accessToken: response.data[ACCESS_TOKEN],
            })
          );
          const redirectUrl = response.data?.recovery_code_is_used
            ? '/2fa/options'
            : props.redirectUrl;
          // fetch user by token
          Promise.all([
            http.get(API_ME),
            props.getAuthPermissions(),
            props.getOrganizationSettings(),
            props.getOrganizationMenuSetup(),
            props.getAllPresets(),
          ]).then(([user]) => {
            const authInfo = {
              ...response.data,
              ...user.data,
            };
            props.setAuthInfo(authInfo);
            StorageService.set(AUTH, JSON.stringify(authInfo));
            setSubmitting(false);
            if (!response.data?.recovery_code_is_used) {
              StorageService.remove(TWO_FACTOR_AUTH);
            }
            props.navigate(redirectUrl);
          });
        });
      } catch ({ response }) {
        const status = response?.status;
        if (status === 429) {
          setErrors({ error: 'rateLimit' });
        } else {
          setErrors({ error: 'invalid' });
        }
      } finally {
        setSubmitting(false);
      }
    };

    if (twoFactorAuth?.initiate2FA && !props.hasRecoveryCodes) {
      try {
        await http
          .post(API_2FA_VERIFY, { code: values.code })
          .then(({ data }) => {
            props.setHasRecoveryCodes(true);
            props.setRecoveryCodes(data?.codes);
            setSubmitting(false);
          });
      } catch ({ response }) {
        const status = response?.status;
        if (status === 429) {
          setErrors({ error: 'rateLimit' });
        } else {
          setErrors({ error: 'invalid' });
        }
        setSubmitting(false);
      }
    } else {
      handleLogin();
    }
  },
})(LoginAuthenticationFormLayout);

const LoginAuthenticationForm = ({ recoveryCodes = [], ...props }) => (
  <LoginAuthenticationFormWithFormik recoveryCodes={recoveryCodes} {...props} />
);

LoginAuthenticationForm.propTypes = {
  setAuthInfo: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  hasRecoveryCodes: PropTypes.bool.isRequired,
  setHasRecoveryCodes: PropTypes.func.isRequired,
  recoveryCodes: PropTypes.array,
  setRecoveryCodes: PropTypes.func.isRequired,
};

export default LoginAuthenticationForm;
